import { render, staticRenderFns } from "./ActivateVacancyModal.vue?vue&type=template&id=16c25ea0&scoped=true"
import script from "./ActivateVacancyModal.vue?vue&type=script&lang=js"
export * from "./ActivateVacancyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c25ea0",
  null
  
)

export default component.exports